const HeroSpacer = () => <div className="h-screen min-h-[700px]" aria-hidden="true" />;
export default HeroSpacer;